// Sentry do navegador (`spec/16-observability.md` §4.3, `spec/17-frontend.md` §14).
// DSN opcional em local: sem ele o init é no-op e nada vaza para fora.

import * as Sentry from '@sentry/react';
import { APP_ENV, RELEASE, SENTRY_DSN } from './config.ts';

export function initSentry(): void {
  if (SENTRY_DSN === '') {
    return;
  }
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: APP_ENV,
    release: RELEASE,
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

export const ErrorBoundary = Sentry.ErrorBoundary;
